<div
	class="modal-dialog goreact-modal activity-preview-editor-dialog"
	cdkTrapFocus
	goDialogContent
	[goDialogContentAriaLabelledBy]="dialogTitleId">
	<div class="activity-preview-editor-dialog__live-region" role="status" aria-live="polite" aria-atomic="true">
		{{ statusMessage() }}
	</div>

	<div class="modal-content activity-preview-editor-dialog__content">
		<header class="goreact-modal-header activity-preview-editor-dialog__header">
			@if (canNavigateBack) {
				<button
					type="button"
					class="activity-preview-editor-dialog__back-button btn-none"
					[disabled]="isSaving()"
					[attr.aria-label]="'common_back' | translate"
					disabledInteractive
					(click)="requestNavigateBack()">
					<i class="ficon-app-chevron-left" aria-hidden="true"></i>
				</button>
			} @else if (!isSaveRequired) {
				<button
					type="button"
					class="activity-preview-editor-dialog__back-button btn-none"
					[disabled]="isSaving()"
					[attr.aria-label]="'common_close' | translate"
					disabledInteractive
					(click)="requestCancel()">
					<i class="ficon-app-chevron-left" aria-hidden="true"></i>
				</button>
			}
			<div class="activity-preview-editor-dialog__title-group">
				<h2 class="modal-title activity-preview-editor-dialog__title" [id]="dialogTitleId" tabindex="-1">
					{{ title() }}
				</h2>
				@if (activityTypeLabel(); as activityTypeLabel) {
					<span class="activity-preview-editor-dialog__type-label">
						({{ activityTypeLabel }})
					</span>
				}
			</div>
			<div class="activity-preview-editor-dialog__actions">
				<button
					type="button"
					class="activity-preview-editor-dialog__preview-button btn-none"
					[disabled]="isPreviewUnavailable()"
					[matTooltip]="'activity-preview-editor-preview-unavailable' | translate"
					[matTooltipDisabled]="!isPreviewUnavailable()"
					(click)="requestPreview()"
					disabledInteractive>
					{{ 'common_preview' | translate }}
				</button>
				@if (!isSaveRequired || canNavigateBack) {
					<button
						type="button"
						class="tertiary-btn cancel-btn light activity-preview-editor-dialog__cancel-button"
						[disabled]="isSaving()"
						disabledInteractive
						(click)="requestCancel()">
						{{ 'common_cancel' | translate }}
					</button>
				}
				<button
					type="button"
					class="confirm-button primary-btn activity-preview-editor-dialog__save-button"
					data-cy="activity-preview-editor-save"
					[disabled]="!canSave()"
					[attr.aria-label]="'common_save-and-close' | translate"
					disabledInteractive
					(click)="requestSaveAndClose()">
					@if (isSaving()) {
						<i class="ficon-spinner ficon-spin" aria-hidden="true"></i>
					}
					{{ 'common_save-and-close' | translate }}
				</button>
			</div>
		</header>

		<main class="goreact-modal-body activity-preview-editor-dialog__body">
				@if (store.isLoading()) {
					<div class="activity-preview-editor-dialog__state">
						<i class="ficon-spinner ficon-spin" aria-hidden="true"></i>
						<span>{{ 'common_loading' | translate }}</span>
					</div>
				} @else if (store.error()) {
					<div class="activity-preview-editor-dialog__state activity-preview-editor-dialog__state--error">
						{{ 'common_unknown-error_message' | translate }}
					</div>
				} @else if (activity()) {
				<div
					class="activity-preview-editor-dialog__mobile-tabs"
					role="tablist"
					[attr.aria-label]="'activity-preview-editor-sections' | translate">
					<button
						#previewTab
						id="activity-preview-editor-details-tab"
						type="button"
						role="tab"
						class="activity-preview-editor-dialog__mobile-tab"
						[class.active]="activePreview() === 'details'"
						[attr.aria-selected]="activePreview() === 'details'"
						[attr.aria-controls]="'activity-preview-editor-details-panel'"
						[attr.tabindex]="activePreview() === 'details' ? 0 : -1"
						(click)="activatePreviewTab('details')"
						(keydown)="onPreviewTabKeydown($event, 'details')">
						{{ 'activity-preview-editor-activity-definition' | translate }}
					</button>
					<button
						#previewTab
						id="activity-preview-editor-task-tab"
						type="button"
						role="tab"
						class="activity-preview-editor-dialog__mobile-tab"
						[class.active]="activePreview() === 'task'"
						[attr.aria-selected]="activePreview() === 'task'"
						[attr.aria-controls]="selectedTaskType() == null
							? 'activity-preview-editor-task-overview-panel'
							: 'activity-preview-editor-task-panel'"
						[attr.tabindex]="activePreview() === 'task' ? 0 : -1"
						(click)="activatePreviewTab('task')"
						(keydown)="onPreviewTabKeydown($event, 'task')">
						{{ 'activity-preview-editor-task-list' | translate }}
					</button>
				</div>
				@if (shouldShowTaskPane()) {
					<aside
						class="activity-preview-editor-dialog__task-pane"
						[class.activity-preview-editor-dialog__task-pane--active-mobile]="isTaskOverviewActive()"
						[attr.aria-label]="'activity-preview-editor-sections' | translate">
						<h3 class="activity-preview-editor-dialog__rail-heading">
							{{ 'activity-preview-editor-activity-definition' | translate }}
						</h3>
						<button
							type="button"
							class="activity-preview-editor-dialog__details-button"
							[class.active]="activePreview() === 'details'"
							[attr.aria-current]="activePreview() === 'details' ? 'page' : null"
							(click)="selectActivityDetails()">
							{{ 'activity-info_activity-details' | translate }}
						</button>
						<div
							class="activity-preview-editor-dialog__task-list-panel"
							[attr.id]="selectedTaskType() == null ? 'activity-preview-editor-task-overview-panel' : null"
							[attr.role]="isTaskOverviewActive() ? 'tabpanel' : null"
							[attr.aria-labelledby]="isTaskOverviewActive() ? 'activity-preview-editor-task-tab' : null">
							<div class="activity-preview-editor-dialog__mobile-task-overview">
								<div class="activity-preview-editor-dialog__mobile-task-overview-header">
									<h3
										#taskOverviewTitle
										class="activity-preview-editor-dialog__mobile-task-overview-title"
										tabindex="-1">
										{{ 'activity-preview-editor-tasks-heading' | translate }}
									</h3>
									<task-list-navigator
										[currentTaskIndex]="1"
										[totalTasks]="taskOverviewPagerTotal()"
										[isComplete]="false"
										[previousButtonLabelKey]="'activity-preview-editor-task-overview-nav-back'"
										(navigateForward)="openFirstTaskFromOverview()"
										(openNavigator)="openTaskList()">
									</task-list-navigator>
								</div>
								<p class="activity-preview-editor-dialog__mobile-task-overview-description">
									{{ 'activity-preview-editor-task-list-description' | translate }}
								</p>
								<div class="activity-preview-editor-dialog__mobile-task-overview-divider" aria-hidden="true"></div>
							</div>
							<activity-task-pane
								[isEditMode]="true"
								[titleKey]="'activity-preview-editor-task-list'"
								(taskSelected)="onTaskPaneTaskSelected($event)">
							</activity-task-pane>
						</div>
					</aside>
				}
				<section
					id="activity-preview-editor-details-panel"
					class="activity-preview-editor-dialog__preview"
					role="tabpanel"
					[attr.aria-labelledby]="'activity-preview-editor-details-tab'"
					[hidden]="activePreview() !== 'details'">
					<activity-details></activity-details>
				</section>
				<section
					#taskPreviewPanel
					id="activity-preview-editor-task-panel"
					class="activity-preview-editor-dialog__preview activity-preview-editor-dialog__preview--task"
					role="tabpanel"
					[attr.aria-labelledby]="'activity-preview-editor-task-tab'"
					[hidden]="activePreview() !== 'task' || selectedTaskType() == null">
					<activity-preview-task-panel />
				</section>
			}
		</main>

		<footer class="activity-preview-editor-dialog__mobile-actions">
			@if (!isSaveRequired || canNavigateBack) {
				<button
					type="button"
					class="tertiary-btn cancel-btn activity-preview-editor-dialog__cancel-button"
					[disabled]="isSaving()"
					disabledInteractive
					(click)="requestCancel()">
					{{ 'common_cancel' | translate }}
				</button>
			}
			<button
				type="button"
				class="primary-btn activity-preview-editor-dialog__save-button"
				data-cy="activity-preview-editor-save-mobile"
				[disabled]="!canSave()"
				[attr.aria-label]="'common_save-and-close' | translate"
				disabledInteractive
				(click)="requestSaveAndClose()">
				@if (isSaving()) {
					<i class="ficon-spinner ficon-spin" aria-hidden="true"></i>
				}
				{{ 'common_save-and-close' | translate }}
			</button>
		</footer>
	</div>
</div>
